import {trackOfferClick} from "../../offer/utils/track_offer_click";
import {hitGtmEvent} from "./track_event";

export interface IOfferTrackingParams {
    offer_id: string;
    offer_name?: string;
    offer_slug?: string;
    /** Preferred GA4 param for brand; falls back from `make` when omitted. */
    brand?: string;
    make?: string;
    model?: string;
    year?: string;
    price?: string | number;
    city?: string;
    page_type?: string;
    list_name?: string;
    /** 1-based position in the list (offer_click). */
    position?: number;
}

const buildOfferParams = (props: IOfferTrackingParams) => {
    const {offer_id, offer_name, offer_slug, brand, make, model, year, price, city, page_type, list_name, position} = props;
    const brandValue = brand || make;

    return {
        offer_id: String(offer_id),
        ...(offer_name ? {offer_name} : {}),
        ...(offer_slug ? {offer_slug} : {}),
        ...(brandValue ? {brand: brandValue, make: brandValue} : {}),
        ...(model ? {model} : {}),
        ...(year ? {year} : {}),
        ...(price != null && price !== "" ? {price} : {}),
        ...(city ? {city} : {}),
        ...(page_type ? {page_type} : {}),
        ...(list_name ? {list_name} : {}),
        ...(position != null ? {position} : {})
    };
};

/** Offer detail page view → GTM dataLayer → GA4 (via GTM tag). */
export const hitOfferViewEvent = (props: IOfferTrackingParams) => {
    if (!props.offer_id) {
        return;
    }

    hitGtmEvent("offer_view", buildOfferParams(props));
};

/** Offer card / list click → GTM dataLayer → GA4 + backend stats.clicks. */
export const hitOfferClickEvent = (props: IOfferTrackingParams) => {
    if (!props.offer_id) {
        return;
    }

    // Backend click counter (list → detail only; do not call from offer detail view).
    trackOfferClick(props.offer_id);
    hitGtmEvent("offer_click", buildOfferParams(props));
};
